import { Device } from 'DeviceUtils';
import { Button, Hr } from 'LocalGluons';
import React, { useEffect } from 'react';
import { View, Text } from 'react-native';
import baseStyles, { landscapeStyles } from './MirroringPreventDialog.jss';
import { isLandscape } from 'react-native-device-info';
import { t } from 'Locale';
import { logEvent } from 'AppManager';

interface MirroringPreventDialogProps {
    setModalContent: (state: any) => void;
    onClose?: () => void;
}

const MirroringPreventDialog: React.FC<MirroringPreventDialogProps> = (props) => {
    const { setModalContent, onClose } = props;

    useEffect(() => {
        logEvent({
            type: 'user-flow',
            subtype: 'player',
            content1: 'mirroring-blocked',
            content2: '',
            context: '/detail'
        });
    }, []);
    return (
        <View style={baseStyles.backgroundContainer}>
            <View style={baseStyles.contentContainer}>
                <Text style={baseStyles.title}>{t('COMMON.INFORMATION')}</Text>
                <View style={baseStyles.hr}>
                    <Hr />
                </View>
                <Text style={baseStyles.content}>{t('SYSTEM_MIRRORING.FEATURE_NOT_SUPPORTED_TXT')}</Text>
                <Button title={t('COMMON.I_UNDERSTAND')} onPress={() => {
                    setModalContent(null);
                    if (onClose)
                        onClose();
                }} />
            </View>
        </View>
    );
};

export default MirroringPreventDialog;